import { fromEvent } from "rxjs";

export const onWindowResize = fromEvent(window, "resize");